import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import './styles.css';

export default class Link extends Component {
  static propTypes = {
    secondary: PropTypes.bool
  }

  static defaultProps = {
    secondary: false
  }

  render() {
    const { label, className, secondary, ...rest } = this.props;
    const textStyle = secondary ? 'type__link__secondary' : 'type__link__primary';
    return (
      <div className="link__container">
        <RouterLink className={`link__href ${className} ${textStyle}`} {...rest}>{this.props.children}</RouterLink>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/Link/Link.js